import React from 'react';
import logoAsset from '../assets/logo-asset.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  centered?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', centered = false }) => {
  const sizeClasses = {
    sm: 'max-h-10',
    md: 'max-h-12',
    lg: 'max-h-16',
    xl: 'max-h-24'
  };

  return (
    <div className={`flex items-center mb-8 ${centered ? 'justify-center' : ''}`}>
      <img 
        src={logoAsset} 
        alt="Catat Crypto" 
        className={`${sizeClasses[size]} w-auto max-w-full object-contain logo-img`}
      />
    </div>
  );
};

export default Logo;
